import React from "react";
import { FiSearch } from "@react-icons/all-files/fi/FiSearch";
import { FaArrowCircleRight } from "@react-icons/all-files/fa/FaArrowCircleRight";
import * as styles from "/src/components/SearchBar.module.css";

export const SearchBar = ({
  searchQuery,
  inputHandler,
  submitHandler,
  className,
}) => {
  const keyPressHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };
  return (
    <div className={className + " " + styles.searchbar}>
      <FiSearch fontSize={25} color="black" />
      <input
        placeholder="Search"
        type="text"
        value={searchQuery}
        onInput={inputHandler}
        onKeyPress={keyPressHandler}
      />
      <FaArrowCircleRight
        onClick={submitHandler}
        fontSize={25}
        className={styles.submitButton}
      />
    </div>
  );
};
